<div class="filter-container">

  <div class="filter-header">
    <i class="fas fa-filter filter-header-icon-container"></i>
    <span>FILTRES DE RECHERCHE</span>
  </div>

  <form [formGroup]="formSearch" class="filter-form">
    <div class="filter-form-container">
      <div class="filter-form-inputs">
        <input type="text"
               formControlName="denominationArticle"
               placeholder="Libellé article">
        <input type="text"
               formControlName="referenceInterneArticle"
               placeholder="Réf. article">
        <input type="text"
               formControlName="lotArticle"
               placeholder="Lot interne article">
        <input type="text"
               formControlName="lotArticleFournisseur"
               placeholder="Lot fournisseur article">
        <dx-date-box id="dateLivStart"
                     placeholder="Filtrer par date de début de mouvement"
                     [(value)]="dateLivraisonStartSelected" type="date"
                     (onValueChanged)="refreshData()">
        </dx-date-box>
        <dx-date-box id="dateLivEnd"
                     placeholder="Filtrer par date de fin de mouvement"
                     [(value)]="dateLivraisonEndSelected" type="date"
                     (onValueChanged)="refreshData()">
        </dx-date-box>
      </div>
    </div>

    <div class="filter-form-container">
      <div class="filter-form-checkbox-container">
        <span class="bold">Mouvements</span>
        <div class="filter-form-checkbox-group">
          <div class="filter-form-checkbox">
            <dx-check-box name="filterEntree"
                          (onValueChanged)="filterTypeMouvements($event, 'E')">
            </dx-check-box>
            <i class="fas fa-arrow-right filter-form-icon new-color"></i>
            Entrées
          </div>
          <div class="filter-form-checkbox">
            <dx-check-box name="filterSortie"
                          (onValueChanged)="filterTypeMouvements($event, 'S')">
            </dx-check-box>
            <i class="fas fa-arrow-left filter-form-icon danger-color"></i>
            Sorties
          </div>
        </div>
      </div>
    </div>

    <div class="filter-form-container">
      <div class="filter-form-inputs">
        <dx-list
          [dataSource]="mouvementsStatut"
          selectionMode="all"
          selectAllMode="allPages"
          displayExpr="libelle"
          valueExpr="id"
          keyExpr="id"
          [height]="250"
          [showSelectionControls]="true"
          [searchEnabled]="true"
          searchExpr="libelle"
          searchMode="contains"
          [selectedItemKeys]="idsTypesMouvSelected"
          (onSelectionChanged)="onChangeTypeMouv($event)">
          <dxo-search-editor-options
            placeholder="Filtrer par type de mouvement">
          </dxo-search-editor-options>
        </dx-list>
      </div>
    </div>

    <div class="filter-form-container">
      <div class="filter-form-inputs">
        <dx-list
          [dataSource]="sites"
          selectionMode="all"
          selectAllMode="allPages"
          displayExpr="libelle"
          valueExpr="id"
          keyExpr="id"
          [height]="250"
          [showSelectionControls]="true"
          [searchEnabled]="true"
          [selectedItemKeys]="idsSitesSelected"
          (onSelectionChanged)="onChangeSite($event)"
          searchExpr="libelle"
          searchMode="contains">
          <dxo-search-editor-options
            placeholder="Filtrer par site">
          </dxo-search-editor-options>
        </dx-list>
      </div>
    </div>

    <div class="filter-form-container">
      <div class="filter-form-inputs">
        <dx-tree-view
          #treeViewZonesStockages
          [dataSource]="zonesStockages"
          [searchEditorOptions]="{placeholder: 'Filtrer par zone de stockage'}"
          keyExpr="id"
          [height]="250"
          selectionMode="multiple"
          showCheckBoxesMode="normal"
          [selectNodesRecursive]="true"
          [selectByClick]="true"
          [searchEnabled]="true"
          (onItemSelectionChanged)="changeZoneStockage($event)"
          searchExpr="label"
          searchMode="contains"
          itemTemplate="itemTemplate">
          <div *dxTemplate="let item of 'itemTemplate'">
            <i class="{{ item.icon }}" ></i> {{ item.label }}
          </div>
        </dx-tree-view>
      </div>
    </div>

  </form>
</div>

